import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { useMemo } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { operatorsWithoutValue } from '../api';
import { defineStyles } from '../theme';
import ConditionColumn from './ConditionColumn';
import ConditionValueField from './ConditionValueField';
import { FilteringDropdown } from './FilteringDropdown';
import { getOperatorItems } from './helpers';
const styles = defineStyles({
    filterRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    columnDropdown: {
        mr: 1,
        '& .MuiButton-root': {
            fontWeight: 'bold',
        },
    },
    operatorDropdown: {
        '& .MuiButton-root': {
            textWrap: 'nowrap',
        },
    },
    fieldValue: {
        width: '100%',
        '& input': {
            width: '100%',
            fontWeight: 'bold',
        },
    },
});
export function ConditionForm({ disabled, andConditionsIndex, orConditionsIndex, filterColumns, disabledOperators, enableAutocomplete, }) {
    const { control, setValue } = useFormContext();
    const fieldValue = useWatch({
        name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.field`,
    });
    const operatorValue = useWatch({
        name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.operator`,
    });
    const column = useMemo(() => filterColumns.find((f) => f.fieldName === fieldValue), [fieldValue, filterColumns]);
    const operatorItems = useMemo(() => getOperatorItems(column, disabledOperators), [column, disabledOperators]);
    return (_jsxs(Box, { sx: styles.filterRow, children: [_jsx(ConditionColumn, { disabled: disabled, control: control, andConditionsIndex: andConditionsIndex, orConditionsIndex: orConditionsIndex, filterColumns: filterColumns }), _jsx(Controller, { name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.operator`, control: control, render: ({ field }) => (_jsx(FilteringDropdown, { value: field.value, items: operatorItems, onSelectedItemChange: (item) => {
                        if (!item?.value)
                            return;
                        if (operatorsWithoutValue.includes(item.value))
                            setValue(`andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.value`, 
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            undefined);
                        field.onChange(item.value);
                    }, placeholder: _jsx(FormattedMessage, { id: "tableFiltering.operator.placeholder", defaultMessage: "Operator" }), sx: styles.operatorDropdown, disabled: disabled ?? !fieldValue })) }), !operatorsWithoutValue.includes(operatorValue) && (_jsx(ConditionValueField, { disabled: disabled, control: control, andConditionsIndex: andConditionsIndex, orConditionsIndex: orConditionsIndex, fieldName: fieldValue?.toString() ?? null, operator: operatorValue ?? null, filterColumn: filterColumns.find((f) => f.fieldName === fieldValue) ?? null, enableAutocomplete: enableAutocomplete }))] }));
}
//# sourceMappingURL=ConditionForm.js.map